module.exports = __webpack_public_path__ + "static/media/headphones-alt.26e68922.svg";